import { render, staticRenderFns } from "./MultiStandardCategoriesSelector.vue?vue&type=template&id=6b822f5d&"
import script from "./MultiStandardCategoriesSelector.vue?vue&type=script&lang=ts&"
export * from "./MultiStandardCategoriesSelector.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports